import { Component, OnInit } from '@angular/core';
import { AuthService } from '../service/auth.service';

@Component({
    selector: 'app-latest-aaletter',
    templateUrl: './latest-aaletter.component.html',
    styleUrls: ['./latest-aaletter.component.scss'],
    standalone: false
})
export class LatestAALetterComponent implements OnInit {

  token : string = "";

  constructor(private userService: AuthService) { }

  ngOnInit() {
    this.token = this.userService.getAaToken();
  }

}
